var WalletType;
(function (WalletType) {
    WalletType["Metamask"] = "metamask";
    WalletType["WalletConnect"] = "walletconnect";
    WalletType["Torus"] = "torus";
})(WalletType || (WalletType = {}));
export default WalletType;
